/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Box, Grid, Typography} from "@mui/material";
import logo from '../../Recursos/logo_oscuro.png'
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {useNavigate} from "react-router-dom";
import {SECCIONES} from "../../Constantes";


const BarraPc = () => {
    const {ir} = useIrRuta()
    const navigate = useNavigate();

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 2, color: '#fff'}}
            >


                <Grid
                    container
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 7}}>

                    <Typography
                        onClick={() => ir(SECCIONES[0])}
                        sx={{
                            fontWeight: 600,
                            fontSize: 14,
                            cursor: 'pointer',
                            borderBottom: 1,
                            transition: 'all .2s ease-in-out',
                            borderColor: '#ffffff00',
                            '&:hover': {
                                borderColor: '#fff'
                            }
                        }}>{SECCIONES[0]}</Typography>

                    <Typography
                        onClick={() => ir(SECCIONES[1])}
                        sx={{
                            fontWeight: 600,
                            fontSize: 14,
                            cursor: 'pointer',
                            borderBottom: 1,
                            transition: 'all .2s ease-in-out',
                            borderColor: '#ffffff00',
                            '&:hover': {
                                borderColor: '#fff'
                            }
                        }}
                    >{SECCIONES[1]}</Typography>

                    <Box>
                        <img src={logo} width={70} height={'auto'} alt={"logo"} onClick={() => navigate('/Home')}
                             style={{cursor: 'pointer'}}
                        />
                    </Box>

                    <Typography
                        onClick={() => ir(SECCIONES[2])}
                        sx={{
                            fontWeight: 600,
                            fontSize: 14,
                            cursor: 'pointer',
                            borderBottom: 1,
                            transition: 'all .2s ease-in-out',
                            borderColor: '#ffffff00',
                            '&:hover': {
                                borderColor: '#fff'
                            }
                        }}
                    >{SECCIONES[2]}</Typography>

                    <Typography
                        onClick={() => ir(SECCIONES[3])}
                        sx={{
                            fontWeight: 600,
                            fontSize: 14,
                            cursor: 'pointer',
                            borderBottom: 1,
                            transition: 'all .2s ease-in-out',
                            borderColor: '#ffffff00',
                            '&:hover': {
                                borderColor: '#fff'
                            }
                        }}
                    >{SECCIONES[3]}</Typography>

                </Grid>


            </Grid>

        </Grid>
    )

}
export default BarraPc

